import { LogLevel } from "@azure/msal-browser";

export const msalConfig = {
  auth: {
    clientId: "b389b78b-286d-4f02-a446-aa96589566cf",
    authority:
      "https://login.microsoftonline.com/917e089c-b09f-4d37-a3f1-e9bd458311cc",
    // redirectUri: "http://localhost:5500",
    redirectUri: "https://raminggunning.ingenium-group.be",
  },
  cache: {
    cacheLocation: "sessionStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            // console.error(message);
            return;
          case LogLevel.Info:
            // console.info(message);
            return;
          case LogLevel.Verbose:
            // console.debug(message);
            return;
          case LogLevel.Warning:
            // console.warn(message);
            return;
          default:
            return;
        }
      },
    },
  },
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
  scopes: [
    "api://a906924b-04e1-4bec-8646-c48c1df0fac1/user_impersonation",
    "User.Read",
  ],
};
